import { LoadingButton } from '@mui/lab';
import { useSegment } from 'common/hooks/segment';
import { Routes } from 'constants/pages';
import * as React from 'react';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { AvailableCompany, joinCompanyWithScac } from 'services/clients/user';

interface Props {
  company: AvailableCompany;
}

export const RequestJoinCompany: React.FC<Props> = (props: Props) => {
  const { company } = props;

  const navigate = useNavigate();
  const { track } = useSegment();

  const joinWithScacMutation = useMutation(joinCompanyWithScac, {
    onSuccess: (data) => {
      track(
        'User asked to join by domain',
        {
          uiFlow: 'domain',
          success: true,
          error: '',
        },
        { includeUser: true }
      );
      if (data.code === 'company_joined') {
        navigate(Routes.Landing);
        return;
      }
      navigate(Routes.AwaitingAdmin);
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError: (e: any) => {
      track(
        'User asked to join by domain',
        {
          uiFlow: 'domain',
          success: false,
          error: e?.response?.data?.code || e?.message || '',
        },
        { includeUser: true }
      );
    },
    mutationKey: ['joinCompanyWithScac', company.id],
  });

  return (
    <div className=" border border-gray-300 rounded px-3 py-5 space-y-1">
      <div className="flex items-center space-x-2">
        <h3 className="font-bold">{company.name}</h3>
        <div className="flex-grow">
          {joinWithScacMutation.isError && (
            <div className="text-red-900">Could not join company.</div>
          )}
        </div>
        <LoadingButton
          onClick={() => joinWithScacMutation.mutate(company.id)}
          variant="contained"
          loading={joinWithScacMutation.isLoading}
        >
          Request to Join
        </LoadingButton>
      </div>
    </div>
  );
};
